import { Outlet } from '@tanstack/react-router';
import { SupportModal, NavbarDefault } from 'app/components';

const ListRouter = () => {
  return (
    <div>
      <div className="grid--container full--height columns">
        <div className="content">
          <Outlet />
        </div>
      </div>
      <NavbarDefault />
      <SupportModal />
    </div>
  );
};

export default ListRouter;
